<template>
  <main>
    <banner
      title="Discover the Fitness SPIRAL®"
      image="/img/backgrounds/running.jpg"
      :extra-styles="{backgroundPosition: 'top'}"
    />

    <span
      id="spirals"
      class="hidden"
    />

    <div class="container-fluid bg-logo-green bg-fixed py-3 py-sm-5">
      <div class="container bg-white p-3 p-sm-5 mb-3 mb-sm-5">
        <div class="row">
          <div class="col-12">
            <h2 class="text-center">
              Discover the Fitness SPIRAL®
            </h2>
          </div>
        </div>
      </div>

      <div class="container bg-white p-3 p-sm-5">
        <div class="row">
          <div class="col-12 col-md-3">
            <ul
              id="spiralsTabs"
              class="nav nav-pills nav-pills-green flex-row flex-md-column justify-content-center"
              role="tablist"
              aria-orientation="vertical"
            >
              <li
                v-for="(spiral) in spirals"
                :key="spiral.id"
                class="nav-item"
              >
                <a
                  :id="'tab-' + spiral.id"
                  class="nav-link"
                  :class="{'active': currentSpiral == spiral.id}"
                  data-toggle="tab"
                  :href="'#tab-pane-' + spiral.id"
                  role="tab"
                  :aria-controls="'tab-pane-' + spiral.id"
                  :aria-selected="currentSpiral == spiral.id ? 'true' : 'false'"
                >{{ spiral.name }}</a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-9">
            <div
              id="spiralsTabContent"
              class="tab-content"
            >
              <div
                v-for="spiral in spirals"
                :id="'tab-pane-' + spiral.id"
                :key="spiral.id"
                class="tab-pane fade show"
                :class="{'active': currentSpiral == spiral.id}"
                role="tabpanel"
                :aria-labelledby="'tab-' + spiral.id"
              >
                <div class="row">
                  <div class="col-12 text-center">
                    <h2 class="mb-5">
                      {{ spiral.name }} Fitness SPIRAL®
                    </h2>
                    <img
                      v-if="spiral.image"
                      :src="spiral.image.path_full"
                      :alt="spiral.name"
                      width="80%"
                      height="auto"
                    >
                  </div>
                  <div class="col-12 mt-5">
                    <div v-html="spiral.description" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import FitnessSpirals from '../services/fitness-spirals.js';

export default {
  beforeRouteEnter(to,from,next){
    FitnessSpirals.published().then(res => {
      next(vm => {
        vm.spirals = res.data;
        vm.setCurrentSpiral();
      })
    })
  },
  data () {
    return {
      spirals: [],
      currentSpiral: null
    }
  },
  methods: {
    setCurrentSpiral() {
      if (this.spirals.length > 0) {
        this.currentSpiral = this.$route.query.spiral ? this.$route.query.spiral : this.spirals[0].id
      }
    }
  }
}
</script>
